import React from 'react';
import styles from './QuickActionCard.module.css';

const QuickActionCard = ({
  icon,
  label,
  onclick,
  backgroundColor,
  NoBgIcon,
}) => {
  return (
    <div
      className={styles.card}
      onClick={onclick}
      style={{ backgroundColor: backgroundColor }}
    >
      {icon && <div className={styles.iconCircle}>{icon}</div>}
      {NoBgIcon && <span>{NoBgIcon}</span>}
      <p className={styles.label}>{label}</p>
    </div>
  );
};

export default QuickActionCard;
